import { render } from "./Designations.vue?vue&type=template&id=543d3528"
import script from "./Designations.vue?vue&type=script&lang=js"
export * from "./Designations.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__